import { useEffect } from "react";
import { PUBLIC_PAGE_META, SITE_URL } from "../lib/pageMeta";

const q = (sel) => document.querySelector(sel);
const metaTags = () => [q('meta[name="description"]'), q('meta[property="og:description"]'), q('meta[name="twitter:description"]')];
const titleTags = () => [q('meta[property="og:title"]'), q('meta[name="twitter:title"]')];
const DEFAULT = PUBLIC_PAGE_META["/"];

function setHeadLink(rel, href) {
  let el = q(`link[rel="${rel}"]`);
  if (!href) return el?.remove();
  if (!el) { el = document.createElement("link"); el.rel = rel; document.head.appendChild(el); }
  el.href = href;
}

function setOgUrl(url) {
  let el = q('meta[property="og:url"]');
  if (!url) return el?.remove();
  if (!el) { el = document.createElement("meta"); el.setAttribute("property", "og:url"); document.head.appendChild(el); }
  el.setAttribute("content", url);
}

function apply(title, description, url) {
  document.title = title;
  titleTags().forEach((t) => t?.setAttribute("content", title));
  metaTags().forEach((t) => t?.setAttribute("content", description));
  setHeadLink("canonical", url);
  setOgUrl(url);
}

// Route-level title/description (+ canonical/og:url for public pages); restores defaults on unmount.
export default function usePageMeta(title, description, path) {
  useEffect(() => {
    apply(title, description, path ? SITE_URL + (path === "/" ? "/" : path) : null);
    return () => apply(DEFAULT.title, DEFAULT.description, null);
  }, [title, description, path]);
}

export const usePublicPageMeta = (path) => usePageMeta(PUBLIC_PAGE_META[path].title, PUBLIC_PAGE_META[path].description, path);
